<script setup lang="ts">
import { numHelper } from '@/utils/numHelper.ts'
import { computed } from 'vue'

interface Props {
  percent?: number | string | null;
}

const props = defineProps<Props>();

const percent = computed(() => (props.percent ? numHelper(props.percent).format(2) : '--'));
</script>

<template>
<span>{{percent}}</span><sup>%</sup>
</template>

<style lang="scss">

</style>
